export function formatPercentage(value: number) {
  return Number.isInteger(value) ? `${value}%` : `${value.toFixed(1)}%`;
}

export function clampPercentage(value: number) {
  return Math.min(Math.max(value, 0), 100);
}
